import cartFields from './cartFields.fragment'

/** GraphQL query to fetch a cart */
export default `
  query cart($cartId: String!) {
    cart(cart_id: $cartId) {
        ${cartFields}
    }
  }
`
